import axios from "axios";
import { auth } from "../firebase";
import { v1BaseUrl } from "./apiBaseUrl";

const v1Api = axios.create({ baseURL: v1BaseUrl });

v1Api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    localStorage.setItem("@token", token);
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function dataOf(response) {
  return response?.data?.data ?? response?.data ?? [];
}

export async function listSessionContent(sessionId) {
  const response = await v1Api.get("notes", {
    params: { curriculum_session_id: Number(sessionId), pageSize: 100, pageNumber: 1 },
  });
  const data = dataOf(response);
  return Array.isArray(data) ? data : [];
}

export async function createSessionContent(sessionId, payload) {
  return dataOf(await v1Api.post("notes", {
    ...payload,
    curriculum_session_id: Number(sessionId),
    note_type: "NOTE",
  }));
}

export async function updateSessionContent(noteId, sessionId, payload) {
  return dataOf(await v1Api.put(`notes/${noteId}`, {
    ...payload,
    curriculum_session_id: Number(sessionId),
    note_type: "NOTE",
  }));
}

export async function deleteSessionContent(noteId) {
  return dataOf(await v1Api.delete(`notes/${noteId}`));
}
